export { default } from "./InputControl";
